<template>
<div class="main__section">
      <sidebar></sidebar>
      <div class="detailedstep">
        <div class="detailedstep__form">
              <p class="detailedstep__title">Company description</p>
              <div class="detailedstep__input">
                <textarea name="company_description" id="company-description" cols="30" rows="6" placeholder="Tell us what you do*" class="input__text" v-model="form.company_description"></textarea>
                  <span class="detailedstep__error" v-if="$v.form.company_description.$error && !$v.form.company_description.required">This field is required</span>
                  <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__input">
                <input type="text" name="keywords" placeholder="Keywords*" class="input__text" v-model="form.keywords"/>
                  <span class="detailedstep__error" v-if="$v.form.keywords.$error && !$v.form.keywords.required">This field is required</span>
                  <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <p class="detailedstep__title detailedstep__title--gray">Separate keywords using a comma</p>
              <div class="detailedstep__input">
                <multiselect name="number_of_employees" id="number_of_employees" :options="optionsEmployees" :searchable="false" :close-on-select="true"  placeholder="Number of employees*" v-model="$v.form.number_of_employees.$model" class="input__select" :class="{ 'input__text--error': $v.form.number_of_employees.$error }">
                </multiselect>
                <span class="detailedstep__error" v-if="$v.form.number_of_employees.$error && !$v.form.number_of_employees.required">Select number of employees</span>
                <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <p class="detailedstep__title mg-btm-25">Where did you hear about us?</p>
              <div class="detailedstep__input">

                  <input type="text" name="keywords" placeholder="Ex. google*" class="input__text" v-model="form.referrer"/>
                  <span class="detailedstep__error" v-if="$v.form.referrer.$error && !$v.form.referrer.required">This field is required</span>
                  <span class="detailedstep__valid" v-else>Field ok</span>
              </div>
              <div class="detailedstep__form detailedstep__form--two mg-tp-45">
                  <a href="#" class="button__next button__next--fixed text-white" @click.prevent="goBack()">Back</a>
                  <a href="#" class="button__next text-white" @click.prevent="saveData()">Next Step</a>
              </div> 
        </div>
      </div>
      <single-testimonial></single-testimonial>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions} from "vuex";
import SingleTestimonial from '../testimonials/SingleTestimonial';
import Sidebar from '../sidebar/Sidebar';
import { required } from 'vuelidate/lib/validators';

export default {

components:{
  'multiselect':Multiselect,
  'sidebar':Sidebar,
  'single-testimonial':SingleTestimonial
},
data(){
  return{
    form:{
      company_description:'',
      keywords:'',
      number_of_employees:'',
      referrer:''
    },
    optionsEmployees:['1 to 5 employees','5 to 25 employees', '25 to 50 employees','over 50 employees'],
    optionsWhereDidYouHear:['Youtube','Google', 'Linkedin']
  }
},
validations:{
   form:{
       company_description: {
         required,
       },
       keywords: {
         required
       },
        number_of_employees:{
          required
        },
        referrer:{
          required
        }
   }       
},
methods:{
  ...mapActions([
    'saveSeo',
    'changeStep'
  ]),
  saveData(){
    this.$v.$touch();

    if(this.$v.$invalid){
        return;
    }else{
      this.saveSeo(this.form);
    }
  },
  goBack(){
        this.changeStep(2);
    }
}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>